import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Star } from '@/components/ui/star.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

export default function RatingEmptyState() {
  return (
    <div data-testid={DataTestIdEnum.ENTITY_EMPTY_RATING} className="flex gap-6 md:py-3">
      <Star rating={0} />
      <Typography variant={TypographyVariant.BODY_TEXT} className="text-gray-700 text-wrap pr-10 sm:pr-0">
        Ainda não temos avaliações aqui
      </Typography>
    </div>
  );
}
